
  import React from 'react'
  import { MDXTag } from '@mdx-js/tag'
  import { Playground } from 'docz';
import Footer from '@devsisters/ui-careers/lib/Footer';

const layoutProps = {
  
};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props)
    this.layout = null
  }
  render() {
    const { components, ...props } = this.props

    return <MDXTag
             name="wrapper"
             
             components={components}>
<MDXTag name="h1" components={components} props={{"id":"footer"}}>{`Footer`}</MDXTag>
<MDXTag name="p" components={components}>{`사이트 하단 푸터 입니다.`}</MDXTag>
<MDXTag name="pre" components={components}><MDXTag name="code" components={components} parentName="pre" props={{"className":"language-tsx"}}>{`import { Footer } from '@devsisters/ui/careers';
// 또는 import Footer from '@devsisters/ui-careers/lib/Footer';
`}</MDXTag></MDXTag>
<MDXTag name="h3" components={components} props={{"id":"놀이터"}}>{`놀이터`}</MDXTag>
<Playground __position={0} __code={'<h1>pc</h1>\n<p>pc 타입은 가로폭 1200px 이상에서 제대로 보입니다.</p>\n<Footer\n  type=\"pc\"\n  links={[\n    { text: \'링크1\', to: \'#link1\' },\n    { text: \'링크2\', to: \'#link2\' },\n    { text: \'링크3\', to: \'#link3\' },\n  ]}\n  links2={[{ text: \'링크4\', to: \'#link4\' }, { text: \'링크5\', to: \'#link5\' }]}\n  snsLinks={{\n    facebook: \'https://www.facebook.com/CookieRunKR\',\n    twitter: \'https://twitter.com/CookieRunKR\',\n    linkedin: \'https://www.linkedin.com/company/devsisters\',\n  }}\n/>\n<h1>mobile</h1>\n<Footer\n  type=\"mobile\"\n  links={[\n    { text: \'링크1\', to: \'#link1\' },\n    { text: \'링크2\', to: \'#link2\' },\n    { text: \'링크3\', to: \'#link3\' },\n  ]}\n  links2={[{ text: \'링크4\', to: \'#link4\' }, { text: \'링크5\', to: \'#link5\' }]}\n  snsLinks={{\n    facebook: \'https://www.facebook.com/CookieRunKR\',\n    twitter: \'https://twitter.com/CookieRunKR\',\n    linkedin: \'https://www.linkedin.com/company/devsisters\',\n  }}\n/>'} __scope={{props: this ? this.props : props,Footer}}>
  <h1>pc</h1>
  <p>pc 타입은 가로폭 1200px 이상에서 제대로 보입니다.</p>
  <Footer
    type='pc'
    links={[
      { text: '링크1', to: '#link1' },
      { text: '링크2', to: '#link2' },
      { text: '링크3', to: '#link3' },
    ]}
    links2={[
      { text: '링크4', to: '#link4' },
      { text: '링크5', to: '#link5' },
    ]}
    snsLinks={{
      facebook: 'https://www.facebook.com/CookieRunKR',
      twitter: 'https://twitter.com/CookieRunKR',
      linkedin: 'https://www.linkedin.com/company/devsisters',
    }}
  />
  <h1>mobile</h1>
  <Footer
    type='mobile'
    links={[
      { text: '링크1', to: '#link1' },
      { text: '링크2', to: '#link2' },
      { text: '링크3', to: '#link3' },
    ]}
    links2={[
      { text: '링크4', to: '#link4' },
      { text: '링크5', to: '#link5' },
    ]}
    snsLinks={{
      facebook: 'https://www.facebook.com/CookieRunKR',
      twitter: 'https://twitter.com/CookieRunKR',
      linkedin: 'https://www.linkedin.com/company/devsisters',
    }}
  />
</Playground>
           </MDXTag>
  }
}
  